<template>
  <div v-if="visible" class="mp-modal-mask" @click.self="close">
    <div class="mp-modal">
      <span class="mp-modal__close" @click="close">×</span>
      <img v-if="coverUrl" :src="coverUrl" alt="" />
      <div v-else class="mp-modal__ph">{{ name }}</div>
      <h3>{{ name }}</h3>
      <p class="mp-modal__brief">{{ brief }}</p>
      <button class="mp-modal__use" type="button" @click="useTemplate">立即使用</button>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed, watch } from 'vue'
import { useMarketPortal } from '../useMarketPortal'
import { useMarketPortalStore } from '../useMarketPortalStore'

defineOptions({ name: 'MarketPreviewModal' })

const props = defineProps<{
  visible: boolean
  templateId?: number
}>()

const emit = defineEmits<{
  'update:visible': [v: boolean]
}>()

const { openEditor } = useMarketPortal()
const { getTemplateName, getTemplateBrief, getCoverUrl, ensureTemplate } = useMarketPortalStore()

watch(
  () => props.templateId,
  (id) => {
    if (id) ensureTemplate(id)
  },
  { immediate: true }
)

const name = computed(() => (props.templateId ? getTemplateName(props.templateId) : ''))
const brief = computed(() => (props.templateId ? getTemplateBrief(props.templateId) : ''))
const coverUrl = computed(() => (props.templateId ? getCoverUrl(props.templateId) : undefined))

const close = () => emit('update:visible', false)

const useTemplate = () => {
  close()
  openEditor(props.templateId)
}
</script>

<style lang="scss" scoped>
.mp-modal-mask {
  position: fixed;
  inset: 0;
  background: rgb(0 0 0 / 50%);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.mp-modal {
  background: #fff;
  border-radius: 12px;
  width: 420px;
  padding: 22px;
  position: relative;

  img {
    width: 100%;
    border-radius: 8px;
    display: block;
  }

  &__ph {
    width: 100%;
    height: 200px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #5b8def, #8b6df0);
    color: #fff;
    font-weight: 600;
  }

  h3 {
    font-size: 16px;
    margin: 12px 0 4px;
  }

  &__brief {
    color: #909399;
    font-size: 13px;
    margin-bottom: 14px;
  }

  &__use {
    background: #2b6de8;
    color: #fff;
    border-radius: 15px;
    padding: 6px 18px;
    font-size: 13px;
    border: none;
    cursor: pointer;
  }

  &__close {
    position: absolute;
    top: 12px;
    right: 14px;
    font-size: 18px;
    color: #909399;
    cursor: pointer;
  }
}
</style>
